import React from 'react';
import HomeButton from '../components/HomeButton/HomeButton';
import './Home.css'; // Plik z dodatkowymi stylami dla Home

import { ZAKODOWANE, WIZUALIZACJE } from '../constans/tableCalls';
import { useStateValue } from '../stateProvider/stateProvider';
import { LOGOUT, SET_CHOOSEN_TABLE } from '../constans/reducerActions';
import { Navigate } from 'react-router';
import Header from '../elements/Header/Header';
import { ADMIN, USER } from '../constans/roles';



const Home = () => {
  const [reducer,dispatch] = useStateValue();

  console.log(USER)
  console.log(reducer.role)

  return (
    <>
      <Header />
    <div className="home-container">
    
      <h1 style={{textAlign:'center', color:'var(--main-font)', width:'80%'}}> 

      </h1>
     
      <HomeButton 
        to="/panel" 
        icon="📸" 
        title="Panel" 
        description="Przejdź do panelu wizualizacji"
        callback={ () => {dispatch({
            type: SET_CHOOSEN_TABLE,
            item: WIZUALIZACJE,
        })
        }} 
      />

<HomeButton 
        to="/panel" 
        icon="💻" 
        title="Panel" 
        description="Przejdź do panelu animacji"
        callback={ () => {dispatch({
            type: SET_CHOOSEN_TABLE,
            item: ZAKODOWANE,
        })}} 
      />


  <HomeButton 
        to="/slideshow" 
        icon="🎞️" 
        title="Slideshow" 
        description="Utwórz i edytuj wizualizacje"
      />

   

<HomeButton 
        to="/footer" 
        icon="✉" 
        title="Generator stopki" 
        description="Wygeneruj odpowiednią stopkę"
      />

{
  (reducer.role  === ADMIN )&&
      <HomeButton 
        to="/linki" 
        icon="💽" 
        title="Kreator linków" 
        description="Stwórz linki kreacji"
      />
}

{
  (reducer.role  === ADMIN )&&
      <HomeButton 
        to="/register" 
        icon="📋" 
        title="Dodaj użytkownika" 
        description="Formularz rejestracji"
      />
}

    <HomeButton 
        to="/login" 
        icon="💔" 
        title="Wyloguj się" 
        description="PaPa :C"
        callback={ () => {dispatch({
            type: LOGOUT,
        })}} 
      />
    </div>
    </>
  );
};

export default Home;

/*




*/